import { useContext, useState } from "react";
import PrestacionContext from '../../context/PrestacionesContext/PrestacionContext';
import {openUpdateModal} from '../../context/PrestacionesContext/Actions'
import { ErrorAlert } from '../../alerts/errorAlert';
import DeleteConfirmModal from './DeleteConfirmModal';
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import Box from '@mui/material/Box';
import MoreVertIcon from '@material-ui/icons/MoreVert';
// import VisibilityIcon from '@mui/icons-material/Visibility';
import { DELETE_PRESTACION, GET_ALL_PRESTACIONES } from "../../Querys/prestaciones/querys";
import { useMutation } from "@apollo/client";
import CheckPermission from "../../helpers/Administradores/Permissions";

export const MenuPrestacion = ({ id, paquetes = [] }: any) => {
    const {dispatch} = useContext(PrestacionContext)

    const [anchorEl, setAnchorEl] = useState<any>(null);
    const [deleteTargetId, setDeleteTargetId] = useState<string | null>(null);
    const open = Boolean(anchorEl);
    const openMenu = (e: any): void => {
      setAnchorEl(e.currentTarget);
    };

    const [deletePrestacion] = useMutation(DELETE_PRESTACION, {
      refetchQueries: [
          { query: GET_ALL_PRESTACIONES }
      ],
  });

    // const verPrestacion = (id:string, verModal: boolean) =>{
    //   setAnchorEl(null);
    //   console.log(id, verModal)
    //   // updateCalendarsModal(id, updateModal, dispatch)
    // }

    const updateModal = (id:string, updateModal: boolean) =>{
      setAnchorEl(null);    
      openUpdateModal(id, dispatch)      
    }

    const deleteModal = (idPrestacion: any) => {
      setAnchorEl(null);

      const enPaquetes = paquetes.filter((p: any) =>
        p.prestaciones?.some((pr: any) => String(pr.id) === String(idPrestacion))
      );

      if (enPaquetes.length > 0) {
        ErrorAlert({
          text: `Esta prestación no puede eliminarse porque pertenece a ${enPaquetes.length} paquete${enPaquetes.length === 1 ? '' : 's'} de prestaciones.`,
        });
        return;
      }

      setDeleteTargetId(String(idPrestacion));
    }

    const handleConfirmDelete = async () => {
      if (!deleteTargetId) return;
      try {
        await deletePrestacion({ variables: { deletePrestacionId: parseInt(deleteTargetId) } });
      } catch (e) {
        ErrorAlert({ text: 'Ocurrió un error al eliminar la prestación.' });
      }
    }

    const menuDelete = ()=>{
         return <MenuItem onClick={() => deleteModal(id)}>
                <div className="contenedorTextoMenuPrestacion" >
                    <span className="textoMenuEliminarPrestacion">Eliminar</span>
                </div>
                <div className="imgDeletePres">
                    <img 
                     className="iconoMenuEliminarPrestacion"
                     src="/assets/svg/icono-eliminar.svg" alt="Eliminar" />
                </div>
            </MenuItem>        
          }  
    return (
        <>
          <DeleteConfirmModal
            open={deleteTargetId !== null}
            title="¿Estás seguro de que quieres eliminar la prestación?"
            onClose={() => setDeleteTargetId(null)}
            onConfirm={handleConfirmDelete}
          />

          <Box mr={2}
             className="menuListNewPrestacion">
                <IconButton onClick={openMenu}
                   className="menuListOptionNewPrestacion"
                 >
                  <MoreVertIcon  className="moreOptionNewPrestacion"  />  
                  </IconButton>
                </Box>
            <Menu
                className="MoreVerIcon"
                anchorEl={anchorEl}
                open={open}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                onClose={() => setAnchorEl(null)}>
                {/* {CheckPermission("Calendario.AgregarDiaInhabil") && (
                <MenuItem 
                       onClick={() => verPrestacion(props.id, true)}
                     >
                    <div   className="contenedorTextoMenuPrestacion" >
                        <span className="textoMenuEditarPrestacion" >Información</span>
                    </div>
                    <div>
                        <VisibilityIcon className="iconoMenuViewPrestacion"                        />
                    </div>
                </MenuItem>
                )} */}
                {CheckPermission("Calendario.EditarCalendario") && (
                <MenuItem onClick={() => updateModal(id, true)}>
                    <div  className="contenedorTextoMenuPrestacion" >
                        <span className="textoMenuEditarPres" >Editar</span>
                    </div>
                    <div  className="imgEditaPres" >
                        <img className="iconoMenuPres"   src="/assets/svg/icono-editar.svg" alt="Editar" />
                    </div>
                </MenuItem>
                )}
                {CheckPermission("Calendario.EliminarCalendario") && ( 
                     menuDelete()             
                 )}
            </Menu>   
           
        </>
    )
}